import React from 'react'

type ModalActionHandler = () => void

export type ModalPropsContextValue = {
  backLabel?: React.ReactNode
  cancelLabel?: React.ReactNode
  confirmIcon?: React.ComponentProps<
    typeof import('components/shared/Button/Button').Button
  >['icon']
  confirmLabel?: React.ReactNode
  isConfirmDisabled?: boolean
  isOpen: boolean
  title?: React.ReactNode
}

export type ModalHandlersContextValue = {
  onBack?: ModalActionHandler
  onCancel?: ModalActionHandler
  onClose: ModalActionHandler
  onConfirm?: ModalActionHandler
}

export const ModalPropsContext = React.createContext<
  ModalPropsContextValue | undefined
>(undefined)
export const ModalHandlersContext = React.createContext<
  ModalHandlersContextValue | undefined
>(undefined)
